(function () {
  'use strict';

  var DURATION = 300; // ms

  function getContent(details) {
    return (
      details.querySelector(':scope > .menu-accordion__content') ||
      details.querySelector(':scope > .menu-accordion__list')
    );
  }

  function animateOpen(details) {
    var el = getContent(details);
    if (!el) return;

    el.style.overflow = 'hidden';
    el.style.maxHeight = '0px';
    el.style.transition = 'none';
    el.offsetHeight; // force reflow
    el.style.transition = 'max-height ' + DURATION + 'ms ease';
    el.style.maxHeight = el.scrollHeight + 'px';

    var done = false;
    function cleanup() {
      if (done) return;
      done = true;
      el.style.maxHeight = '';
      el.style.overflow = '';
      el.style.transition = '';
    }
    el.addEventListener('transitionend', function onEnd(e) {
      if (e.propertyName !== 'max-height') return;
      el.removeEventListener('transitionend', onEnd);
      cleanup();
    });
    setTimeout(cleanup, DURATION + 50);
  }

  function animateClose(details, callback) {
    var el = getContent(details);
    if (!el) { callback(); return; }

    el.style.overflow = 'hidden';
    el.style.maxHeight = el.scrollHeight + 'px';
    el.style.transition = 'none';
    el.offsetHeight; // force reflow
    el.style.transition = 'max-height ' + DURATION + 'ms ease';
    el.style.maxHeight = '0px';

    var done = false;
    function finish() {
      if (done) return;
      done = true;
      callback();
      el.style.maxHeight = '';
      el.style.overflow = '';
      el.style.transition = '';
    }
    el.addEventListener('transitionend', function onEnd(e) {
      if (e.propertyName !== 'max-height') return;
      el.removeEventListener('transitionend', onEnd);
      finish();
    });
    setTimeout(finish, DURATION + 50);
  }

  function initMenuAccordion() {
    document.querySelectorAll('.menu-accordion > summary, .menu-accordion__sub-summary').forEach(function (summary) {
      summary.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var details = summary.parentElement;
          if (!details) return;

          if (details.open) {
            summary.setAttribute('aria-expanded', 'false');
            animateClose(details, function () {
              details.open = false;
            });
          } else {
            details.open = true;
            summary.setAttribute('aria-expanded', 'true');
            animateOpen(details);
          }
        },
        true // キャプチャフェーズ: HeaderDrawer の onSummaryClick より先に処理
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenuAccordion);
  } else {
    initMenuAccordion();
  }
})();
